import '|/app.styl';
import 'animate.css';
import 'waypoints/lib/jquery.waypoints.min.js';

(function ($) {

    // This is for everyone
    window.$      = $;
    window.jQuery = jQuery;

    $(document).ready(function () {

        // Fade sponsors in
        $('.sponsors-card').waypoint(
            function () {
                $(this.element)
                    .addClass('animated fadeInUp');
            },
            {
                offset: '100%'
            }
        );

    });

})(jQuery);